import { render, staticRenderFns } from "./ActionsSection.vue?vue&type=template&id=02dce942"
import script from "./ActionsSection.vue?vue&type=script&lang=js"
export * from "./ActionsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ActionsCarousel: require('/opt/build/repo/components/actions/ActionsCarousel.vue').default})
